import { z } from 'zod';
import {
  taxonomyNodeKinds,
  taxonomyNodeStatuses,
  taxonomyPromptTypes,
} from '../../types/entities/taxonomy.entity';

export const TrilingualLabelsSchema = z.object({
  en: z.string().min(1),
  nl: z.string().min(1),
  fr: z.string().min(1),
});

export type TrilingualLabelsValidator = z.infer<typeof TrilingualLabelsSchema>;

export const TaxonomyPromptValidatorSchema = z
  .object({
    type: z.enum(taxonomyPromptTypes),
    title: TrilingualLabelsSchema,
    optionsSource: z.literal('children'),
  })
  .nullable()
  .optional();

export type TaxonomyPromptValidator = z.infer<
  typeof TaxonomyPromptValidatorSchema
>;

export const CreateTaxonomyNodeValidatorSchema = z.object({
  id: z.string().min(1),
  // Nullable: top-level categories have no parent (mirrors the backend's
  // CreateTaxonomyNodeBody.parentId, which is mandatory-but-nullable).
  parentId: z.string().min(1).nullable(),
  kind: z.enum(taxonomyNodeKinds),
  selectable: z.boolean(),
  sortOrder: z.number(),
  labels: TrilingualLabelsSchema,
  prompt: TaxonomyPromptValidatorSchema,
});

export type CreateTaxonomyNodeValidator = z.infer<
  typeof CreateTaxonomyNodeValidatorSchema
>;

// NO `id` / `parentId` / `kind` / `selectable` — the node id is immutable by
// construction (only ever supplied via the URL param on PATCH, never the body).
export const UpdateTaxonomyNodeValidatorSchema = z.object({
  labels: TrilingualLabelsSchema.optional(),
  prompt: TaxonomyPromptValidatorSchema,
  sortOrder: z.number().optional(),
  status: z.enum(taxonomyNodeStatuses).optional(),
});

export type UpdateTaxonomyNodeValidator = z.infer<
  typeof UpdateTaxonomyNodeValidatorSchema
>;

// Move is a dedicated endpoint rather than part of PATCH, so a node's
// structural position (reparenting) stays separate from content edits.
export const MoveTaxonomyNodeValidatorSchema = z.object({
  parentId: z.string().min(1),
});

export type MoveTaxonomyNodeValidator = z.infer<
  typeof MoveTaxonomyNodeValidatorSchema
>;
